import { motion } from "framer-motion";

const PHOTOS = [
  {
    id: "machinery",
    base: "https://images.unsplash.com/photo-1597974380476-fbf652dfe188?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxkcmlsbGluZyUyMG1hY2hpbmVyeSUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzkxOTg3OTAxfDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop",
    caption: "Utilaj de foraj în lucru",
    big: true,
  },
  {
    id: "team",
    base: "https://images.unsplash.com/photo-1628155849837-648cf206ec31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxkcmlsbGluZyUyMHJpZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjB3b3JrZXJ8ZW58MHx8fHwxNzkxOTg3OTI5fDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop",
    caption: "Echipa la lucru, în teren",
  },
  {
    id: "water",
    base: "https://images.unsplash.com/photo-1606214554814-e8a9f97bdbb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxjbGVhbiUyMGZyZXNoJTIwd2F0ZXIlMjBzcGxhc2glMjBibHVlfGVufDB8fHx8MTc5MTk4NzkwMXww&ixlib=rb-4.1.0&q=85&auto=format&fit=crop",
    caption: "Apă limpede, la pompaj",
  },
  {
    id: "yard",
    base: "https://images.unsplash.com/photo-1790039139966-1de90bbc7152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHw0fHxkcmlsbGluZyUyMHJpZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjB3b3JrZXJ8ZW58MHx8fHwxNzkxOTg3OTI5fDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop",
    caption: "Foraj în curți și spații greu accesibile",
  },
  {
    id: "casing",
    base: "https://images.unsplash.com/photo-1690473768476-44b5cebb7d80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxkcmlsbGluZyUyMHJpZyUyMGNvbnN0cnVjdGlvbiUyMHNpdGUlMjB3b3JrZXJ8ZW58MHx8fHwxNzkxOTg3OTI5fDA&ixlib=rb-4.1.0&q=85&auto=format&fit=crop",
    caption: "Tubulare și filtrare la adâncime",
  },
];

const pic = (p, w) => `${p.base}&w=${w}`;

export default function GallerySection() {
  return (
    <section id="galerie" className="scroll-mt-16 bg-hydro-deep py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
              Galerie
            </p>
            <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl md:text-6xl">
              Lucrări din teren.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-white/55">
            Utilaje reale, foraje reale — așa arată o zi de muncă în București și Ilfov.
          </p>
        </motion.div>

        <div className="mt-12 grid grid-cols-2 gap-3 md:grid-cols-4 md:auto-rows-[230px]">
          {PHOTOS.map((p, i) => {
            const big = p.big || i === 0;
            return (
              <motion.figure
                key={p.id}
                data-testid={`gallery-item-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.15 }}
                transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className={`group relative overflow-hidden rounded-2xl ${big ? "col-span-2 row-span-2" : ""} h-52 md:h-auto`}
              >
                <img
                  src={pic(p, 1000)}
                  srcSet={[600, 1000, 1600].map((w) => `${pic(p, w)} ${w}w`).join(", ")}
                  sizes={big ? "(max-width: 767px) 100vw, 50vw" : "(max-width: 767px) 50vw, 25vw"}
                  alt={p.caption}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-hydro-navy/85 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-4 left-4 right-4 translate-y-3 font-display text-sm font-bold text-white opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {p.caption}
                </figcaption>
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
